import { Features } from 'generated/featureDefinitions'
import { FinancialWorkspaceAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export interface FinancialWorkspaceAvailabilities {
  features: {
    dev_test_de_verdad: boolean
    dev_fw_additional_compensations: boolean
  }
  modules: {
    expenses: boolean
    payroll: boolean
    projects: boolean
    compensations: boolean
  }
  loading: boolean
}

interface Props {
  skip?: boolean
}

export const useFinancialWorkspaceAvailabilities = (
  props?: Props
): FinancialWorkspaceAvailabilities => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(FinancialWorkspaceAvailabilitiesDocument, {
    variables: {
      companyId: company.id,
    },
    skip: props?.skip,
    fetchPolicy: 'network-only',
  })

  const features = data?.features?.featuresConnection?.nodes
    .filter((feature) => feature.enabled)
    .map((feature) => feature.name)

  const featureAvailabilities = data?.companies.featureAvailabilities?.nodes || []
  const availableExpensesModule = data?.companies.expensesAvailability?.available ?? false
  const availablePayrollModule = data?.companies.payrollAvailability?.available ?? false
  const availableProjectsModule =
    featureAvailabilities.find((feature) => feature.id === Features.projects_core)?.available ??
    false
  const availableCompensationsModule =
    featureAvailabilities.find((feature) => feature.id === Features.compensations_management)
      ?.available ?? false

  const dev_fw_additional_compensations =
    features?.includes('dev_fw_additional_compensations') ?? false
  const dev_test_de_verdad = features?.includes('dev_fw_test_testdeverdad') ?? false

  return {
    features: {
      dev_test_de_verdad,
      dev_fw_additional_compensations,
    },
    modules: {
      expenses: availableExpensesModule,
      payroll: availablePayrollModule,
      projects: availableProjectsModule,
      compensations: availableCompensationsModule,
    },
    loading,
  }
}
